import { Section, SectionCard } from "@blueprintjs/core";
import { MediaFolderTree } from "./MediaFolderTree";
import { MediaGridBreadCrumbs } from "./MediaGridBreadCrumbs";
import { MediaGridToolbar } from "./MediaGridToolbar";
import { MediaTilePanel } from "./MediaTilePanel";

type MediaGridProps = {
  showFolderTree?: boolean;
};

export function MediaGrid({ showFolderTree = true }: MediaGridProps) {
  return (
    <div className="flex flex-col">
      <MediaGridToolbar />
      <div className="mt-4">
        <Section elevation={1}>
          <SectionCard padded={false}>
            <MediaGridBreadCrumbs />
          </SectionCard>
          <SectionCard padded={false} className="flex flex-row">
            {showFolderTree && (
              <div className="w-64 shrink-0 border-r border-brand-line bg-brand-paper p-2">
                <MediaFolderTree />
              </div>
            )}
            <div className="grow min-w-0 p-4">
              <MediaTilePanel />
            </div>
          </SectionCard>
        </Section>
      </div>
    </div>
  );
}
